<script src="../../router/index.js"></script>
<template>
  <div id="main-content" >
    <a-spin :spinning="dataLoad">
      <div v-if="dataList.length===0"
           style="width: 100%;height: 100%;background: #ffffff;display: flex;flex-flow: column;align-items: center;justify-content: center" >
        <div style="margin: 10px 0;font-size: 18px;">您还未添加任何图表，请点击下方按钮添加</div>
        <a-button type="primary" @click="addReport()">添加图表</a-button>
      </div>
      <a-row :gutter="16" >
        <a-col style="height: 10vw;margin-bottom: 10px;cursor: pointer;"
               :key="dataItem.code"
               :span="6" v-for="dataItem in dataList">
          <div @click="watchReport(dataItem.code)" style="height: 100%;border-radius: 5px;background: #ffffff;padding: 10px;display: flex;flex-flow: column">
            <div style="flex: 1">
            </div>
            <div style="font-size: 18px;margin: 10px 0">
              {{dataItem.name}}
            </div>
            <div style="display: flex;justify-content: space-between">
              <div>{{dataItem.group_name}}&nbsp;&nbsp;-&nbsp;&nbsp;{{dataItem.user_name}}</div>
              <div style="display: flex;align-items: center" @click.stop>
                <a-tag>{{$store.state.report.panelType[dataItem.type]}}</a-tag>
                <a-popconfirm
                  v-if="dataItem.user_id===$store.state.UserInfo.id"
                  style="color: #cf1322;cursor: pointer"
                  title="此操作会删除当前面板?"
                  ok-text="删除"
                  cancel-text="取消"
                  @confirm="deletePanel(dataItem.code)"
                >
                  <a-icon type="delete" />
                </a-popconfirm>
              </div>
            </div>
          </div>
        </a-col>
      </a-row>
    </a-spin>
  </div>
</template>

<script>
import {DeletePanel, GetPanelList} from "../../api/v1/analysis";

export default {
  name: "List",
  data(){
    return {
      dataList:[],
      dataLoad:false,
    }
  },
  mounted() {
    this.getDataList()
  },
  methods:{
    getDataList(){
      this.dataLoad = true
      GetPanelList({}).then(resp => {
        if (resp.code===200){
          this.dataLoad = false
          this.dataList = resp.data
        }
      })
    },
    watchReport(code){
      let query = this.$route.query
      query.code = code
      this.$router.push({path:'/report_index',query:query})
    },
    addReport(){
      this.$router.push({path:'/report_add',query:this.$route.query})
    },
    deletePanel(code){
      DeletePanel({code:code}).then(resp => {
        if (resp.code===200){
          this.$message.success("删除成功")
          this.getDataList()
        }
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/Report/List.vue